import React from 'react';
import OrderServiceTableRow from './OrderServiceTableRow'
import {View, StyleSheet, Text } from '@react-pdf/renderer';
import OrderServiceTableHeader from './OrderServiceTableHeader'
import OrderServiceTasksTableRow from './OrderServiceTasksTableRow';
import OrderServiceTasksTableHeader from './OrderServiceTasksTableHeader';

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderRadius:'5px',
        borderColor: '#000000 ',
    },
    reportText:{
        marginTop: 15,
        color: '#000',
        letterSpacing: 1,
        fontSize: 11
    },
});

const OrderServiceTasksTable = ({data}) => {
    const dados = ((data.orderService && data.orderService?.tasksAndItens.length > 0)) ? data.orderService?.tasksAndItens : []
    return <>
        <Text style={styles.reportText}>TAREFAS</Text>
        <View style={styles.tableContainer}>
            <OrderServiceTasksTableHeader />
            <OrderServiceTasksTableRow items={dados} />
            {/* <OrderServiceTableFooter items={data.services} /> */}
        </View>
    </>
};

export default OrderServiceTasksTable